import { useCateringToastStore } from '../../store/useToast';

const variantConfig: Record<string, { border: string; symbol: string; iconColor: string }> = {
  success: { border: 'var(--green, #30A46C)', symbol: 'check_circle', iconColor: 'var(--green, #30A46C)' },
  error: { border: 'var(--red, #E5484D)', symbol: 'cancel', iconColor: 'var(--red, #E5484D)' },
  warning: { border: 'var(--orange, #E5A100)', symbol: 'warning', iconColor: 'var(--orange, #E5A100)' },
  info: { border: 'var(--accent, #D23A3B)', symbol: 'info', iconColor: 'var(--accent, #D23A3B)' },
};

export function CateringToastContainer() {
  const toasts = useCateringToastStore((s) => s.toasts);
  const removeToast = useCateringToastStore((s) => s.removeToast);

  if (toasts.length === 0) return null;

  return (
    <div
      role="region"
      aria-label="Notifications"
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        pointerEvents: 'none',
      }}
    >
      {toasts.map((toast) => {
        const config = variantConfig[toast.type] || variantConfig.info;
        return (
          <div
            key={toast.id}
            role="status"
            aria-live="polite"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '10px 14px 10px 12px',
              background: 'var(--surface, #FFFFFF)',
              border: '1px solid var(--card-border, #E2E5EC)',
              borderLeft: `3px solid ${config.border}`,
              borderRadius: 'var(--radius-input, 8px)',
              boxShadow: 'var(--shadow, 0 4px 12px rgba(0,0,0,0.12))',
              fontSize: 13,
              fontFamily: 'var(--font-primary)',
              color: 'var(--t1, #1A1D2E)',
              minWidth: 280,
              maxWidth: 400,
              pointerEvents: 'auto',
            }}
          >
            <span
              className="material-symbols-rounded"
              style={{ fontSize: 18, color: config.iconColor, flexShrink: 0 }}
              aria-hidden
            >
              {config.symbol}
            </span>
            <span style={{ flex: 1 }}>{toast.message}</span>
            <button
              type="button"
              onClick={() => removeToast(toast.id)}
              aria-label="Dismiss"
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: 'var(--t3, #9CA3B8)',
                fontSize: 18,
                lineHeight: 1,
                padding: 2,
                flexShrink: 0,
              }}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
